import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Time: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-72.12 0-139.92-28.08-190.92-79.08s-79.08-118.8-79.08-190.92 28.08-139.92 79.08-190.92 118.8-79.08 190.92-79.08 139.92 28.08 190.92 79.08 79.08 118.8 79.08 190.92-28.08 139.92-79.08 190.92-118.8 79.08-190.92 79.08zm0-510c-64.11 0-124.38 24.96-169.71 70.29s-70.29 105.6-70.29 169.71 24.96 124.38 70.29 169.71 105.6 70.29 169.71 70.29 124.38-24.96 169.71-70.29 70.29-105.6 70.29-169.71-24.96-124.38-70.29-169.71-105.6-70.29-169.71-70.29z' />
    <path d='m480 90h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path
      d='m358.08 333.03h123.25v30h-123.25z'
      transform='matrix(.70858619 -.70562427 .70562427 .70858619 -123.27 397.61)'
    />
    <path d='m506.21 240.47-63.64 63.64 21.21 21.21 42.43-42.43c11.72-11.72 11.72-30.71 0-42.43z' />
  </IconBase>
));

Time.displayName = 'Time';

export default Time;
